/* * @Author: yezs * @Date: 2022-04-18 17:46:56 * @Last Modified by: yezs * @Last Modified time: 2022-04-21 15:04:48 */

<template>
  <div>
    <div class="shift-centent">
      <div :class="['shift-date', isApp ? 'no-header' : '']">
        <div class="date-box" @click="show = true">
          <div><van-icon name="notes-o" /> {{ date[0] }}</div>
          <span>至</span>
          <div>{{ date[1] }}</div>
        </div>
      </div>
      <div class="shift-list" v-loading="fullscreenLoading">
        <div class="shift-item" v-for="(item, index) in NursingShift" :key="index">
          <div class="item-title">
            <div>{{ item.CDate | dateFormat('yyyy-mm-dd') }}</div>
            <span>{{ item.FloorNames }}</span>
          </div>
          <div class="item-centent">
            <div class="midday" v-if="item.Morning.ShiftId">
              <div class="midday-title">
                <div class="midday-left">
                  <img :src="require('@/assets/imgs/morning.png').default" alt="" />
                  <span>早班</span>
                  <p>录入人:{{ item.Morning.CUser || '' }}</p>
                </div>
                <span class="midday-right">总人数:{{ item.Morning.ElderlyTotal }}</span>
              </div>
              <div class="midday-content">
                <div class="midday-num">
                  <div>
                    <span>房号：</span>
                    <p>{{ item.Morning.ShiftModels[0].RoomNo }}</p>
                  </div>
                  <div>
                    <span>姓名：</span>
                    <p>{{ item.Morning.ShiftModels[0].PName }}</p>
                  </div>
                </div>
                <div class="midday-text">
                  <span>交班内容：</span>
                  <p>
                    {{ item.Morning.ShiftModels[0].Note }}
                  </p>
                </div>
              </div>
            </div>
            <div class="midday" v-if="item.Middle.ShiftId">
              <div class="midday-title">
                <div class="midday-left">
                  <img :src="require('@/assets/imgs/middle.png').default" alt="" />
                  <span>中班</span>
                  <p>录入人:{{ item.Middle.CUser || '' }}</p>
                </div>
                <span class="midday-right">总人数:{{ item.Middle.ElderlyTotal }}</span>
              </div>
              <div class="midday-content">
                <div class="midday-num">
                  <div>
                    <span>房号：</span>
                    <p>{{ item.Middle.ShiftModels[0].RoomNo }}</p>
                  </div>
                  <div>
                    <span>姓名：</span>
                    <p>{{ item.Middle.ShiftModels[0].PName }}</p>
                  </div>
                </div>
                <div class="midday-text">
                  <span>交班内容：</span>
                  <p>
                    {{ item.Middle.ShiftModels[0].Note }}
                  </p>
                </div>
              </div>
            </div>
            <div class="midday" v-if="item.Night.ShiftId">
              <div class="midday-title">
                <div class="midday-left">
                  <img :src="require('@/assets/imgs/night.png').default" alt="" />
                  <span>晚班</span>
                  <p>录入人:{{ item.Night.CUser || '' }}</p>
                </div>
                <span class="midday-right">总人数:{{ item.Night.ElderlyTotal }}</span>
              </div>
              <div class="midday-content">
                <div class="midday-num">
                  <div>
                    <span>房号：</span>
                    <p>{{ item.Night.ShiftModels[0].RoomNo }}</p>
                  </div>
                  <div>
                    <span>姓名：</span>
                    <p>{{ item.Night.ShiftModels[0].PName }}</p>
                  </div>
                </div>
                <div class="midday-text">
                  <span>交班内容：</span>
                  <p>
                    {{ item.Night.ShiftModels[0].Note }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="item-btn">
            <div class="edit" @click="edit(item)">编辑</div>
            <div class="look" @click="lookData(item)">查看</div>
          </div>
        </div>
      </div>
      <div v-if="NursingShift.length == 0" style="width: 100%; text-align: center">暂无记录</div>
      <van-calendar v-model="show" type="range" @confirm="onConfirm" :default-date="defaultDate" :max-date="new Date()" allow-same-day :min-date="getMinDate()" />
    </div>
  </div>
</template>

<script>
import { Dialog, Toast } from 'vant'
import pager from '@/common/pager.vue'
import { group } from '@/tool'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {
    pager
  },
  // 组件状态值
  data() {
    return {
      isApp: true,
      active: '护士交班',
      NursingShift: [],
      fullscreenLoading: false,
      size: 2,
      page: 1,
      total: 2,
      show: false,
      date: [],
      defaultDate: []
    }
  },
  filters: {
    dateFormat: function (dateStr, pattern = '') {
      var dt = new Date(dateStr)
      var yy = dt.getFullYear()
      var mm = dt.getMonth() + 1 < 10 ? '0' + (dt.getMonth() + 1) : dt.getMonth() + 1
      var dd = dt.getDate() < 10 ? '0' + dt.getDate() : dt.getDate()
      var h = dt.getHours() < 10 ? '0' + dt.getHours() : dt.getHours()
      var m = dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes()
      var s = dt.getSeconds() < 10 ? '0' + dt.getSeconds() : dt.getSeconds()
      if (pattern.toLowerCase() === 'yyyy-mm-dd') {
        return yy + '-' + mm + '-' + dd
      } else {
        return yy + '-' + mm + '-' + dd + ' ' + h + ':' + m
      }
    }
  },
  created() {
    this.date = this.getDate()
    this.defaultDate = this.getDefaultDate()
    this.getNursingShift(this.date[0], this.date[1])
    this.isApp = localStorage.getItem('isApp') === '0'
  },
  // 组件方法
  methods: {
    getMinDate() {
      const date = new Date()
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 30 * 12)
      return date
    },
    getDefaultDate() {
      let nowDate = new Date()
      let date = nowDate.setMonth(nowDate.getMonth() - 1)
      return [new Date(date), new Date()]
    },
    getDate() {
      let nowDate = new Date()
      let date = nowDate.setMonth(nowDate.getMonth() - 1)
      return [this.formatDate(new Date(date)), this.formatDate(new Date())]
    },
    formatDate(date) {
      return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
    },
    onConfirm(date) {
      const [start, end] = date
      this.show = false
      this.date[0] = `${this.formatDate(start)}`
      this.date[1] = `${this.formatDate(end)}`
      this.getNursingShift(this.date[0], this.date[1])
    },
    tabData(item) {
      this.active = item
      if (item == '楼层交班') {
        this.$router.push({
          name: 'floorShift'
        })
      }
    },
    //获取交班信息数据GET /api/Pad/NursingShiftHandover
    getNursingShift(begin, end) {
      this.fullscreenLoading = true
      this.$axios
        .get('/Pad/NursingShiftHandover?begin=' + begin + '&end=' + end)
        .then((res) => {
          this.fullscreenLoading = false
          this.NursingShift = res.data.obj
          this.total = res.data.obj.length
        })
        .catch((err) => {
          this.fullscreenLoading = false
        })
    },

    changeSize(size) {
      this.size = size
    },
    changePage(page) {
      this.page = page
    },
    // 点击到详情
    lookData(data) {
      localStorage.setItem('item', JSON.stringify(data))
      this.$router.push({
        name: 'shiftExchangeDetails',
        query: { type: 0 }
      })
    },
    // 编辑
    edit(data) {
      localStorage.setItem('item', JSON.stringify(data))
      this.$router.push({
        name: 'addShift',
        query: {
          type: 0,
          isEdit: true
        }
      })
    }
  }
}
</script>

<style scoped>
.shift-tab {
  width: 100%;
  height: 50px;
  box-sizing: border-box;
  background-color: #fff;
  padding: 0 15px;
  display: flex;
  position: fixed;
  top: 44px;
}
.shift-box {
  width: 100%;
  border-bottom: 1px solid #ebebeb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.tab-list {
  display: flex;
  height: 100%;
  padding-top: 13px;
  box-sizing: border-box;
}
.tab-item {
  display: flex;
  align-items: center;
  height: 100%;
  margin-right: 20px;
  font-size: 16px;
  position: relative;
}
.add-shift {
  width: 74px;
  height: 32px;
  background-color: #029fd1;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #fff;
}
.on {
  font-weight: bold;
}
.on::after {
  position: absolute;
  bottom: 0;
  width: 64px;
  height: 2px;
  content: '';
  background-color: #029fd1;
}
.shift-centent {
  width: 100%;
}
.shift-date {
  position: fixed;
  top: 94px;
  width: 100%;
  height: 67px;
  background-color: #fff;
  box-sizing: border-box;
  padding: 16px 15px;
  display: flex;
}
.no-header {
  top: 50px !important;
}

.date-box {
  width: 100%;
  display: flex;
  height: 100%;
  background-color: #f4f4f4;
  border-radius: 3px;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 12px;
  font-size: 14px;
}
.shift-list {
  width: 100%;
  box-sizing: border-box;
  padding: 129px 15px 15px 15px;
  display: flex;
  flex-direction: column;
}
.shift-item {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
  border-radius: 4px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
}
.item-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color: #7c7e80;
  padding-bottom: 13px;
  border-bottom: 1px solid #ebebeb;
}
.item-centent {
  margin-top: 8px;
  display: flex;
  flex-direction: column;
}
.midday {
  display: flex;
  flex-direction: column;
}
.midday-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
}
.midday-left {
  display: flex;
  align-items: center;
}
.midday-left img {
  width: 24px;
  height: 24px;
}
.midday-left span {
  font-size: 14px;
  color: #0a0e10;
  font-weight: bold;
  margin-left: 8px;
}
.midday-left p {
  color: #7c7e80;
  font-size: 12px;
  margin: 0;
  margin-left: 20px;
}
.midday-right {
  font-size: 14px;
  color: #029fd1;
  font-weight: bold;
}
.midday-content {
  width: 100%;
  box-sizing: border-box;
  padding: 12px;
  background-color: #f7f8fa;
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.midday-content span {
  font-size: 14px;
  line-height: 20px;
  color: #7c7e80;
}
.midday-content p {
  font-size: 14px;
  line-height: 20px;
  color: #0a0e10;
  margin: 0;
  margin-left: 8px;
  flex: 1;
}
.midday-num {
  display: flex;
  margin-bottom: 12px;
}
.midday-num div {
  flex: 1;
  display: flex;
  align-items: center;
}
.midday-text {
  display: flex;
  align-items: flex-start;
}
.item-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.item-btn div {
  width: 64px;
  height: 32px;
  box-sizing: border-box;
  border: 1px solid #c7c9cc;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: #434649;
  border-radius: 32px;
  margin-left: 15px;
}
.item-btn .look {
  color: #fff;
  background-color: #029fd1;
  border-color: #029fd1;
}
</style>



// WEBPACK FOOTER //
// src/components/shiftExchange/nurseShiftExchange.vue